// Süper admin / bayi › Modül Yönetimi penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'superadmin.moduleSettings';

export const moduleSettingsGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Modül Yönetimi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Bir şirketin hangi modülleri kullanabileceğini, bayiye bağlı şirketlerde bayinin hangi modülleri açabileceğini ve demo bitiş tarihini bu pencereden belirlersiniz. Buradaki ayarlar müşterinin sisteme erişimini doğrudan etkiler. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Şirket ve açık modül sayısı'),
    body: t(`${G}.regions.body`, 'Modüller, bayi izni, demo'),
    footer: t(`${G}.regions.footer`, 'Kaydet'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Şirketi ve durumu kontrol edin'),
      text: t(`${G}.s1.text`, 'Başlıkta şirketin adı ve kaç modülün açık olduğu ("Tümü açık" ya da "5/12 modül açık") görünür. Bayi olarak açtıysanız etiket "İzinli X modülden Y açık" şeklindedir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Modülleri seçin'),
      text: t(`${G}.s2.text`, '"Tüm modüller açık (varsayılan)" açıkken şirket standart modüllerin hepsini kullanır. Kapatırsanız aşağıdaki listeden şirketin satın aldığı modülleri tek tek açıp kapatırsınız. Kapatılan modülün menüleri ve sayfaları şirket kullanıcılarına görünmez.'),
      tips: [
        t(`${G}.s2.tip1`, '"Ayrıca açılır" etiketli modüller (Üretim, Üretim - Operasyonlar, Lot / Parti Takibi) "Tümü açık" kapsamına girmez; yalnız açıkça seçilince açılır.'),
        t(`${G}.s2.tip2`, '"Üretim - Operasyonlar" için önce Üretim modülü açık olmalıdır; Üretim kapatılırsa Operasyonlar da kapanır.'),
        t(`${G}.s2.tip3`, 'Hiçbir modül seçmezseniz şirket kullanıcıları girişte hiçbir menü göremez; pencere bunu uyarı olarak gösterir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Bayiye izin verilen modüller'),
      text: t(`${G}.s3.text`, 'Şirket bir bayiye bağlıysa "Bayiye İzin Verilen Modüller" bölümü görünür. Bayi, bu şirkette yalnız burada izin verdiğiniz modülleri kendi portalından açabilir. "Bayi kısıtlaması yok" açıkken bayi her modülü açabilir.'),
      tips: [
        t(`${G}.s3.tip1`, 'İznini geri aldığınız modül şirkette açıksa otomatik kapanır; yani müşteri o modüle erişimini kaybeder.'),
        t(`${G}.s3.tip2`, 'Her satırdaki "Bayi açtı / Bayi açmadı" etiketi, izinli modülün şirkette şu an açık olup olmadığını gösterir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Demo bitiş tarihini belirleyin'),
      text: t(`${G}.s4.text`, '"Demo Kullanım Sınırı" bölümünde "Demo bitiş tarihi" seçin ya da +7 / +14 / +30 gün düğmeleriyle uzatın (süre dolmuşsa uzatma bugünden başlar). Seçilen tarih o günün sonuna (23:59) kadar geçerlidir. "Demoyu kaldır" şirketi süresiz (kalıcı müşteri) yapar.'),
      tips: [
        t(`${G}.s4.tip1`, 'Tarih geçince şirkete 1 günlük ek süre tanınır ve kullanıcılar uyarı bandı görür; ek süre de bitince tüm modüller kilitlenir, kullanıcılar kilit ekranı görür ve kayıt yapamaz.'),
        t(`${G}.s4.tip2`, 'Şirketin mobil uygulamadan aldığı bir abonelik varsa erişim süresi abonelik bitişine göre belirlenir; demo tarihi o durumda kullanılmaz.'),
        t(`${G}.s4.tip3`, 'Pencerede "Demo doldu" görünüyorsa tarihi uzatın veya demoyu kaldırın.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydedin'),
      text: t(`${G}.s5.text`, '"Kaydet" yalnız bir değişiklik yaptığınızda etkin olur. Önce bayi izinleri, sonra modül ve demo ayarları kaydedilir. "Kapat" kaydetmeden çıkar.'),
    },
    {
      region: 'body',
      title: t(`${G}.s6.title`, '6. Bayi olarak kullanıyorsanız'),
      text: t(`${G}.s6.text`, 'Bayi yalnız merkezin izin verdiği modülleri açıp kapatabilir; kilitli (asma kilit simgeli) modüller için merkez ile iletişime geçmelidir. "Tümü açık" anahtarı ve demo ayarları bayide görünmez; demo süresi yalnız bilgi olarak gösterilir, uzatma yetkisi merkezdedir.'),
    },
  ],
});
